import { useEffect, useId, useMemo } from 'react';
import {
  registerRankChipColors,
  unregisterRankChipColors,
} from '../utils/rankChipCspStyles';

/**
 * Registers rank chip colors for CSP-safe <style nonce> injection (cross-browser).
 * @param {Array<string|null|undefined>|string|null|undefined} colors
 */
export default function useRankChipCspStyles(colors) {
  const subscriberId = useId();
  const normalizedKey = useMemo(() => {
    const list = Array.isArray(colors) ? colors : [colors];
    return list
      .map((c) => (typeof c === 'string' ? c.trim() : ''))
      .filter(Boolean)
      .sort()
      .join('\0');
  }, [colors]);

  useEffect(() => {
    const list = normalizedKey ? normalizedKey.split('\0') : [];
    if (list.length === 0) {
      unregisterRankChipColors(subscriberId);
      return undefined;
    }
    registerRankChipColors(subscriberId, list);
    return () => unregisterRankChipColors(subscriberId);
  }, [subscriberId, normalizedKey]);
}
